<script>
  // @ts-nocheck
  import Alta from './views/Alta.svelte'
  import AltaStatus from './views/AltaStatus.svelte'
  import AltaStatusSin from './views/AltaStatusSin.svelte'
  import Signup from './views/Signup.svelte'
  import ResetPassword from './views/ResetPassword.svelte'
  import ResetPassword2 from './views/ResetPassword2.svelte'
  import TResult from './views/Result.svelte'
  import Testing from './views/Testing.svelte'
  import { Router, Route } from 'svelte-navigator'
  // import Result from '$lib/components/UI/Result.svelte'
  // import Typography from '$lib/components/UI/Typography.svelte'
  import Frame from '$lib/components/layout/Frame.svelte'
  import Login from './views/Login.svelte'
  import { ENV } from '$lib/conf'
  import Home from './views/Home.svelte'
  import { navigate } from 'svelte-navigator'
  import { onMount } from 'svelte'
  import PreguntasFrecuentes from './views/PreguntasFrecuentes.svelte'
  import device from '$lib/stores/device'
  import Redirect from '$lib/components/layout/Redirect.svelte'

  onMount((_) => {
      $device.window = window.screen
      // Solicitud de almacenamiento persistente al sitio
      if (navigator.storage && navigator.storage.persist) {
        navigator.storage.persist().then(isPersisted => {
          console.log(`Persisted storage granted: ${isPersisted}`);
        })
      }
    })
</script>

<!-- svelte-ignore a11y-missing-attribute -->
<svelte:element
  this="html"
  bind:offsetHeight={$device.screen.height}
  bind:offsetWidth={$device.screen.width}
></svelte:element>
<!-- bind:clientHeight={$device.window.height}
bind:clientWidth={$device.window.width} -->
<Router a11y={false}>
  <Route path="/alta/init/*">
      <Router>
          <Route path="/">
              <!-- <Alta/> -->
              {navigate('/login')}
          </Route>
          <Route path="/:uuid" let:params>
              <Alta {...params} />
          </Route>
      </Router>
  </Route>
  <!-- <Route path="/alta/init/:uuid/" let:params>
  <Alta {...params} />
</Route> -->
  <Route path="/alta">
      {navigate('/alta/init', { replace: true })}
  </Route>
  <Route path="/alta/status/:uuid" let:params>
      <AltaStatus uuid={params.uuid} />
  </Route>
  <Route path="/alta/status_sin/:uuid" let:params>
      <AltaStatusSin uuid={params.uuid} />
  </Route>
  <Route path="/alta/status/">
      {navigate('/alta')}
  </Route>
  <Route path="/login" component={Login} />
  <Route path="/signup/:uuid" component={Signup} />
  <Route path="/singup/:uuid" let:params>
      <Redirect path={`/signup/${params.uuid}`} />
  </Route>
  <Route path="/home/*" component={Home} />
  <Route path="/help">
      <Frame title="Preguntas frecuentes">
          <PreguntasFrecuentes />
      </Frame>
  </Route>
  <!-- <Route path="/alta/success" let:location>
  <Frame title="Formulario de Alta">
    <div
      style="display: flex; flex-direction: row; justify-content: center; align-items: center"
    >
      {#if location && location.state && "type" in location.state && location.state.type}
        <Result type={location.state.type}>
          {#if location && location.state && "comment" in location.state && location.state.comment}
            <Typography style="text-align: center" type="h3"
              >{location.state.comment}</Typography
            >
          {/if}
          {#if location && location.state && "uuid" in location.state && location.state.uuid}
            <Typography type="body"
              >RequestId: {location.state.uuid}</Typography
            >
          {/if}
        </Result>
      {:else}
        {navigate("/", { replace: true })}
      {/if}
    </div>
  </Frame>
</Route> -->
  {#if ENV.DEV}
      <Route path="test/*" component={Testing} />
  {/if}
  <Route let:location>
      {navigate(
          `/alta/init/${
              location.pathname.match(/alta\/.+$/)
                  ? location.pathname.split('/').at(-1)
                  : ''
          }`,
          { replace: true }
      )}
  </Route>
  <Route path="preguntas" component={PreguntasFrecuentes} />
  <!-- <Route path="resetPassword/*challenge" component={ResetPassword} /> -->
  <Route path="resetPassword" component={ResetPassword2} />
  <Route path="result" component={TResult} />
</Router>
<!-- Alta Exitosa. Su solicitud está siendo procesada. -->
